import React from 'react'
import CustomTable from '../custom/CustomTable'
import DeleteButton from '../custom/DeleteButton';

export default function UserTechnologyTable({ technologies, currentPageNo=1, totalPages=1, handlePageChange=null, onDelete=null, deleteOff=false, showPagination=true }) {
    const columns = [
        { header: '技術スタック', accessor: 'technology' },
        { header: '技術分類', accessor: 'stack' },
        { header: '経験年数(年間)', accessor: 'experience' },
        { header: 'レベル(1~5)', accessor: 'expert_level' },
    ];

    // Define actions
    const renderActions = (row) => (
        <DeleteButton
            colorScheme='red'
            handleDelete={onDelete}
            id={row?.id}
        />
    );

    return (
        <CustomTable
            columns={columns}
            data={technologies}
            renderActions={deleteOff ? null : renderActions}
            paginationProps={
                showPagination ? {
                    currentPage: currentPageNo,
                    totalPages: totalPages,
                    onPageChange: handlePageChange
                } : null
            }
        />
    )
}
